import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  SurveySubmissionSummaryDto,
  AnswerResponseDto,
  WorkerDemographicsDto,
  PageResponseDto,
  SurveyResponsesQueryParams,
  SurveyAnswersQueryParams,
  WorkerDemographicsQueryParams
} from '../interface/survey-responses.interface';

@Injectable({ providedIn: 'root' })
export class SurveyResponsesService {
  private readonly baseUrl = `${environment.apiUrl}/survey-responses`;

  constructor(private http: HttpClient) {}

  /**
   * Obtiene un listado paginado de resúmenes de respuestas de encuestas
   */
  getSurveySubmissionSummaries(params: SurveyResponsesQueryParams): Observable<PageResponseDto<SurveySubmissionSummaryDto>> {
    let httpParams = new HttpParams()
      .set('campaign', params.campaign);

    if (params.page !== undefined) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.size !== undefined) {
      httpParams = httpParams.set('size', params.size.toString());
    }
    if (params.sort && params.sort.length > 0) {
      params.sort.forEach(sortParam => {
        httpParams = httpParams.append('sort', sortParam);
      });
    }
    if (params.startDate) {
      httpParams = httpParams.set('startDate', params.startDate);
    }
    if (params.endDate) {
      httpParams = httpParams.set('endDate', params.endDate);
    }
    if (params.createdAt) {
      httpParams = httpParams.set('createdAt', params.createdAt);
    }

    return this.http.get<PageResponseDto<SurveySubmissionSummaryDto>>(this.baseUrl, { params: httpParams });
  }

  /**
   * Obtiene respuestas individuales de preguntas
   */
  getSurveyAnswers(params: SurveyAnswersQueryParams): Observable<PageResponseDto<AnswerResponseDto>> {
    const url = `${this.baseUrl}/answers`;
    let httpParams = new HttpParams()
      .set('guideId', params.guideId)
      .set('campaign', params.campaign)
      .set('token', params.token);

    if (params.page !== undefined) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.size !== undefined) {
      httpParams = httpParams.set('size', '100');
    }
    if (params.sort && params.sort.length > 0) {
      params.sort.forEach(sortParam => {
        httpParams = httpParams.append('sort', sortParam);
      });
    }
    if (params.startDate) {
      httpParams = httpParams.set('startDate', params.startDate);
    }
    if (params.endDate) {
      httpParams = httpParams.set('endDate', params.endDate);
    }
    if (params.createdAt) {
      httpParams = httpParams.set('createdAt', params.createdAt);
    }

    return this.http.get<PageResponseDto<AnswerResponseDto>>(url, { params: httpParams });
  }

  /**
   * Obtiene datos demográficos de los trabajadores
   */
  getWorkerDemographics(params: WorkerDemographicsQueryParams): Observable<PageResponseDto<WorkerDemographicsDto>> {
    const url = `${this.baseUrl}/demographics`;
    let httpParams = new HttpParams()
      .set('guideId', params.guideId)
      .set('campaign', params.campaign)
      .set('token', params.token);

    if (params.page !== undefined) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.size !== undefined) {
      httpParams = httpParams.set('size', params.size.toString());
    }
    if (params.sort && params.sort.length > 0) {
      params.sort.forEach(sortParam => {
        httpParams = httpParams.append('sort', sortParam);
      });
    }
    if (params.startDate) {
      httpParams = httpParams.set('startDate', params.startDate);
    }
    if (params.endDate) {
      httpParams = httpParams.set('endDate', params.endDate);
    }
    if (params.createdAt) {
      httpParams = httpParams.set('createdAt', params.createdAt);
    }

    return this.http.get<PageResponseDto<WorkerDemographicsDto>>(url, { params: httpParams });
  }
}
